<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-subtitle v-if="message">{{ message }}</v-card-subtitle>
    <v-card-text>
      <v-form @submit.prevent v-model="valid">
        <v-text-field
          ref="input"
          v-model="input"
          outlined
          dense
          autofocus
          :type="type"
          :hint="hint"
          :prefix="prefix"
          :persistent-hint="!!hint"
          :hide-details="!hint"
          :rules="rules"
          :placeholder="placeholder"
          @keypress.enter.prevent="submit"
        ></v-text-field>
      </v-form @submit.prevent>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text :disabled="loading" @click="$emit('close')">Cancelar</v-btn>
      <v-btn
        color="primary"
        @click="submit"
        :loading="loading"
        :disabled="!valid"
        >Aceptar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';

  @Component
  export default class InputModal extends Vue {
    $refs!: { input: any };
    @Prop() type: string;
    @Prop() title: string;
    @Prop() message: string;
    @Prop() placeholder: string;
    @Prop() hint: string;
    @Prop() rules: any[];
    @Prop() prefix: string;
    @Prop() value?: string;
    input: string = this.value ?? '';
    loading = false;
    valid = false;

    async created() {}

    async submit() {
      this.loading = true;

      await (<Function>this.$parent.$listeners.submit)(this.input);

      this.loading = false;
    }

    mounted() {
      if (this.value) {
        // Use nextTick to ensure DOM is ready
        this.$nextTick(() => {
          try {
            // Navigate through Vuetify's component structure to find the input
            const inputElement = this.$refs.input?.$refs?.input;
            if (inputElement) {
              inputElement.select();
            }
          } catch (error) {
            console.warn('Could not auto-select input text:', error);
          }
        });
      }
    }
  }
</script>
